var _rect, _path, _path2, _path3, _ellipse, _line, _rect2, _rect3, _rect4, _rect5, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSomethingWentWrong(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 161,
    viewBox: "0 0 120 161",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.40015,
    y: 31.3948,
    width: 96.4496,
    height: 108.769,
    fill: "white",
    stroke: "#D4D4D4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.40015 25.6543C5.40015 23.4452 7.19101 21.6543 9.40015 21.6543H97.8497C100.059 21.6543 101.85 23.4452 101.85 25.6543V31.3948H5.40015V25.6543Z",
    fill: "#F6F6F6",
    stroke: "#D4D4D4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7824 43.6166C15.7824 42.6624 16.556 41.8888 17.5103 41.8888L80.5693 41.8888V52.9098C80.5693 53.5186 80.9937 54.0122 81.5174 54.0122H91.5541C91.6599 54.0122 91.7635 53.9918 91.8626 53.9548V127.721C91.8626 128.675 91.089 129.449 90.1347 129.449H17.5103C16.556 129.449 15.7824 128.675 15.7824 127.721L15.7824 43.6166ZM17.5103 40.1609C15.6017 40.1609 14.0545 41.7081 14.0545 43.6166L14.0545 127.721C14.0545 129.63 15.6017 131.177 17.5103 131.177H90.1347C92.0433 131.177 93.5905 129.63 93.5905 127.721V53.0553C93.5905 52.1397 93.2271 51.2615 92.5801 50.6136L83.1555 41.1749C82.5072 40.5257 81.6275 40.1609 80.7101 40.1609L17.5103 40.1609Z",
    fill: "#D4D4D4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3999 20.9892C26.3999 20.9892 32.4787 20.8549 39.9758 20.2374C47.4729 19.6198 45.1292 12.3196 53.5517 12.3196C61.9742 12.3196 57.6042 19.6198 67.1276 20.2374C76.6509 20.8549 80.7035 20.9892 80.7035 20.9892V33.0182H26.3999V20.9892Z",
    fill: "white",
    stroke: "#D4D4D4",
    strokeWidth: 1.5
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 53.8525,
    cy: 20.8425,
    rx: 4.05251,
    ry: 4.05855,
    fill: "#C4C4C4"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 43.7001,
    y1: 27.6479,
    x2: 62.9627,
    y2: 27.6479,
    stroke: "#3C228A",
    strokeLinecap: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 12.937,
    height: 2.43473,
    rx: 1.21737,
    transform: "matrix(0.943987 -0.329983 0.329108 0.944292 106.986 23.1086)",
    fill: "#C4C4C4"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 11.7266,
    height: 2.43184,
    rx: 1.21592,
    transform: "matrix(-0.30123 -0.953552 -0.953293 0.302046 97.5287 16.7593)",
    fill: "#C4C4C4"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 17.9745,
    height: 2.43242,
    rx: 1.21621,
    transform: "matrix(0.503142 -0.864204 0.863551 0.504262 103.744 15.5337)",
    fill: "#C4C4C4"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 74.325,
    y: 148.429,
    width: 34.1007,
    height: 7.30249,
    fill: "url(#paint0_linear_593_432)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M89.372 134.659L93.7546 139.097",
    stroke: "#3C228A",
    strokeWidth: 1.58824,
    strokeLinecap: "square"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M94.4344 129.879L98.8406 134.342",
    stroke: "#3C228A",
    strokeWidth: 1.58824,
    strokeLinecap: "square"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9694 115.232C96.9694 127.633 87.0542 137.615 74.9097 137.615C62.7651 137.615 52.85 127.633 52.85 115.232C52.85 102.832 62.7651 92.8501 74.9097 92.8501C87.0542 92.8501 96.9694 102.832 96.9694 115.232Z",
    stroke: "white",
    strokeWidth: 6.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M99.4252 115.232C99.4252 128.96 88.4398 140.07 74.9097 140.07C61.3795 140.07 50.3941 128.96 50.3941 115.232C50.3941 101.505 61.3795 90.3942 74.9097 90.3942C88.4398 90.3942 99.4252 101.505 99.4252 115.232Z",
    stroke: "#3C228A",
    strokeWidth: 1.58824
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5849 135.27C85.5265 135.27 94.3964 126.4 94.3964 115.459C94.3964 104.517 85.5265 95.6473 74.5849 95.6473C63.6433 95.6473 54.7734 104.517 54.7734 115.459C54.7734 126.4 63.6433 135.27 74.5849 135.27Z",
    fill: "#3C228A",
    fillOpacity: 0.12,
    stroke: "#3C228A",
    strokeWidth: 1.22294
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M109.95 158.91L92.6577 141.398L100.746 133.207L118.038 150.719L109.95 158.91Z",
    fill: "white",
    stroke: "#3C228A",
    strokeWidth: 1.58824
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M99.4956 141.597L101.665 139.4",
    stroke: "#3C228A",
    strokeWidth: 1.58824,
    strokeLinecap: "square"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M101.665 139.4L109.914 147.754",
    stroke: "#3C228A",
    strokeWidth: 1.58824,
    strokeLinecap: "square"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 54.3999,
    width: 54.5604,
    height: 1.76148,
    rx: 0.86394,
    fill: "#D4D4D4"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 75.5376,
    width: 54.5604,
    height: 1.76149,
    rx: 0.86394,
    fill: "#D4D4D4"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 68.4917,
    width: 36.9603,
    height: 1.76145,
    rx: 0.86394,
    fill: "#D4D4D4"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 62.2401,
    y: 68.4917,
    width: 21.1201,
    height: 1.76145,
    rx: 0.86394,
    fill: "#D4D4D4"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 61.4458,
    width: 49.2803,
    height: 1.76149,
    rx: 0.86394,
    fill: "#D4D4D4"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 82.5835,
    width: 49.2803,
    height: 1.76144,
    rx: 0.86394,
    fill: "#D4D4D4"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 73.6807,
    y: 61.4458,
    width: 8.80006,
    height: 1.76149,
    rx: 0.86394,
    fill: "#D4D4D4"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 73.6807,
    y: 82.5835,
    width: 8.80006,
    height: 1.76144,
    rx: 0.86394,
    fill: "#D4D4D4"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_593_432",
    x1: 74.325,
    y1: 155.156,
    x2: 103.051,
    y2: 155.156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F1",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DADCDF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSomethingWentWrong);
export default __webpack_public_path__ + "static/media/something-went-wrong.b297fe621d2b28cfe9e2e9eea0693bb8.svg";
export { ForwardRef as ReactComponent };